import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1","key":"svg-0"}]]

/**
 * IconArrowBack
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctYmFjayIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOSAxMWwtNCA0bDQgNG0tNCAtNGgxMWE0IDQgMCAwIDAgMCAtOGgtMSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-back
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowBack = createReactComponent('outline', 'arrow-back', 'ArrowBack', __iconNode);

export default IconArrowBack;